import { IUserPreferences } from '@epicuro-next/data/users';
import { createAction, props } from '@ngrx/store';

export const postUserPreferences = createAction(
  '[User] Post User Preferences',
  props<{ preferences: Partial<IUserPreferences> }>(),
);
export const postUserPreferencesSuccess = createAction(
  '[User] Post User Preferences Success',
  props<{ preferences: IUserPreferences }>(),
);
export const postUserPreferencesFailure = createAction(
  '[User] Post User Preferences Failure',
  props<{ error: string }>(),
);

export const setPreferredScaleSet = createAction(
  '[User] Set Preferred Scale Set',
  props<{ scaleSetId: string }>(),
);

export const submitAssortmentCode = createAction(
  '[User] Submit Assortment code',
  props<{ assortmentCode: string }>(),
);

export const deleteAssortmentCode = createAction(
  '[User] Delete Assortment code',
  props<{ assortmentCodeIndex: number }>(),
);
